// extracted by mini-css-extract-plugin
export default {"form-control-group":"EditPassword_form-control-group__Qd3Tr","form-control":"EditPassword_form-control__cjgsl","form-actions":"EditPassword_form-actions__SHAo8"};